import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
} from '@mui/material';
import * as React from 'react';
import { TSelect } from './Select.types';
import './Select.styled.scss';
import { isVisibleOnWhite } from 'utils';
import { Clear } from '@mui/icons-material';

export const Select: TSelect = (props) => {
  const selectContainerRef = React.useRef<HTMLDivElement>(null);
  return (
    <div className="select__container" ref={selectContainerRef}>
      <FormControl
        className={props.className}
        size={props.size}
        fullWidth={!props.size}
        error={props.error}
      >
        <InputLabel id={props.id}>{props.label}</InputLabel>
        <MuiSelect
          {...props}
          className="select"
          sx={{
            minWidth: props.minWidth,
            maxWidth: props.maxWidth,
            height: '56px',
          }}
          disabled={props.disabled || !props.options?.length}
          renderValue={(selected: string | string[]) => {
            let isBadgeDisplay = false;
            const selectedOptionsIds = Array.isArray(selected)
              ? selected
              : [selected];

            const selectedOptions = selectedOptionsIds.map((id) => {
              const option = props.options.find((option) => option.id === id);
              if (option?.color) {
                isBadgeDisplay = true;
              }
              return option || { label: id, id };
            });

            return (
              <div className="select__display-row">
                {!isBadgeDisplay ? (
                  <p>{selectedOptions.map((item) => item.label).join(', ')}</p>
                ) : (
                  selectedOptions.map((item) => {
                    return (
                      <div
                        className="select__selected-badge"
                        key={item.id}
                        style={{ backgroundColor: item.color }}
                      >
                        <p
                          style={{
                            color: isVisibleOnWhite(item.color)
                              ? 'white'
                              : 'black',
                          }}
                          className="caption"
                        >
                          {item.label}
                        </p>
                      </div>
                    );
                  })
                )}
              </div>
            );
          }}
        >
          {props?.options?.map?.((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.renderItem ? option.renderItem : option.label}
            </MenuItem>
          ))}
        </MuiSelect>
        {props.helperText && (
          <FormHelperText>{props.helperText}</FormHelperText>
        )}
      </FormControl>
      {props.value?.length && props.isClearable ? (
        <div
          className="select__clear-button"
          style={{ top: selectContainerRef.current?.clientHeight / 2 - 12 }}
          onClick={(e) => {
            e.stopPropagation();
            console.log('CLOCIK');
            props.onChange?.(null, false);
          }}
        >
          <Clear />
        </div>
      ) : null}
    </div>
  );
};
